import { SVGProps } from 'react'

export const Location = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" fill="none" {...props}>
    <g>
      <path
        fill="currentColor"
        d="M10.333 1.667A5.83 5.83 0 004.5 7.5c0 4.375 5.833 10.833 5.833 10.833s5.834-6.458 5.834-10.833a5.83 5.83 0 00-5.834-5.833zm0 7.916a2.084 2.084 0 11.002-4.168 2.084 2.084 0 01-.002 4.168z"
      ></path>
    </g>
  </svg>
)
